import React, { useEffect, useState } from "react";
import CustomCheckbox from "../common/CustomCheckbox";
import ExpireJobsModal from "../mjpModals/ExpireJobsModal";
import RenewJobsModal from "../mjpModals/RenewJobsModal";
import { JobsDataType } from "../../types/api-response";
import ClockIcon from "../icons/ClockIcon";
import RefreshIcon from "../icons/RefreshIcon";
import RenewListModal from "../mjpModals/RenewListModal";
import LowInventoryModal from "../mjpModals/LowInventoryModal";
import { PASSIVE_JOB } from "../../constants/Filters";

interface Props {
  totalRowData: JobsDataType[] | undefined;
  setCheckedData: Function;
  checkedData: JobsDataType[] | undefined;
  active: string;
}

const HeaderActions = ({
  totalRowData = [],
  checkedData,
  setCheckedData,
  active,
}: Props) => {
  const [showExpireModal, setShowExpireModal] = useState(false);
  const [showRenewModal, setShowRenewModal] = useState(false);
  const [showNoCreditsModal, setShowNoCreditsModal] = useState(false);
  const [showRenewButton,setShowRenewButton] = useState(true);

  const selectAllCallBack = (e: any) => {
    if (e?.target?.checked) {
      setCheckedData([...totalRowData]);
    } else {
      setCheckedData([]);
    }
  };

  const checkboxData = {
    label: "Select All",
    id: "selectAll",
    callBack: selectAllCallBack,
  };

  const renewFailedCallBack = () => {
    setShowNoCreditsModal(!showNoCreditsModal);
  }

  const isChecked = Number(checkedData?.length) > 0;

  useEffect(()=>{
   if(checkedData && checkedData.length===1){
    if(checkedData[0].jobFrom === PASSIVE_JOB){
      setShowRenewButton(false)
    }
   }else if(checkedData && checkedData.length>1){
    const isAllJobsPassive = checkedData.every((job)=>job.jobFrom === PASSIVE_JOB)
    if(isAllJobsPassive){
      setShowRenewButton(false)
    }else{
      setShowRenewButton(true)
    }
   }else{
    setShowRenewButton(true)
   }
  },[checkedData])

  return (
    <div className="header_action_container">
      <CustomCheckbox
        checkboxData={checkboxData}
        checked={checkedData?.length === totalRowData?.length}
      />
      <div className="header_action_container_cta-group">
        {active !== "Expired" && (
          <span
            className={isChecked ? "header-cta-icon-container" : ""}
            style={{ display: "flex", gap: "1rem" }}
          >
           {showRenewButton && <button
              className="foundit-button secondaryButton medium"
              onClick={() => setShowRenewModal(true)}
              disabled={!isChecked}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <RefreshIcon />
              Renew
            </button>}
            <button
              className="foundit-button secondaryButton medium"
              onClick={() => setShowExpireModal(true)}
              disabled={!isChecked}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <ClockIcon />
              Expire
            </button>
          </span>
        )}

        {active !== "Active" && showRenewButton && active !== 'Inbound_Jobs' ? (
          <button
            className="foundit-button secondaryButton medium"
            onClick={() => setShowRenewModal(true)}
            disabled={!isChecked}
          >
            <RefreshIcon />
            Renew
          </button>
        ): <div style={{height:'36px'}}></div> }
      </div>

      <ExpireJobsModal
        isOpen={showExpireModal}
        setIsOpen={setShowExpireModal}
        modalData={checkedData}
        setSelectedRowData={setCheckedData}
      />

      <RenewListModal
        isOpen={showRenewModal}
        setIsOpen={setShowRenewModal}
        modalData={checkedData}
        setSelectedRowData={setCheckedData}
        // inventoryError={renewFailedCallBack}
      />

      <LowInventoryModal
        isOpen={showNoCreditsModal}
        setIsOpen={setShowNoCreditsModal}
        modalData={checkedData}
        // hitRate={}
      />
    </div>
  );
};

export default HeaderActions;
